export default __webpack_public_path__ + "static/media/news3.8ce2a3ef.jpg";